import type { RtpSkippedPack } from '../../lib/api/operatorConsole';

/** Why the pack kept its RTP: the server's own words, or its payable range when no words came. */
function reasonLabel(pack: RtpSkippedPack): string {
  if (pack.message) return pack.message;
  const range = pack.reachable_rtp;
  return range ? `can pay ${range[0]}%–${range[1]}% right now` : "can't pay any RTP right now";
}

/** Packs the global RTP was not applied to; each line says why the pack kept its RTP. */
export function SkippedPacksNotice({ packs }: { packs: RtpSkippedPack[] }) {
  if (packs.length === 0) return null;

  return (
    <div
      role="status"
      className="mt-3 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-[12px] text-amber-900"
    >
      <p className="font-semibold">RTP not changed on {packs.length === 1 ? '1 pack' : `${packs.length} packs`}:</p>
      <ul className="mt-1 list-disc pl-4">
        {packs.map((pack) => (
          <li key={pack.pool_offer_id}>
            {pack.title} — {reasonLabel(pack)}
          </li>
        ))}
      </ul>
    </div>
  );
}
